import * as actionTypes from "./types";
import { message } from "antd";
import {
	getAdmissionYearForThirdYearStudents,
	getCurrentAcadimicYear,
} from "../utils/functions/javaScriptHelper";

export const getDashboardProjectLikeStatus =
	(companyId) =>
	(dispatch, getState, { getFirebase, getFirestore }) => {
		dispatch({
			type: actionTypes.SET_DASHBOARD_LIKE_STAT_LOADING,
			payload: true,
		});
		const database = getFirestore();

		database
			.collection("Dashboard_ProjectLikes")
			.where("companyId", "==", companyId)
			.get()
			.then((querySnap) => {
				let likeStatusData = [];
				querySnap.forEach((doc) => {
					let _data = doc.data();
					likeStatusData.push(_data);
				});
				dispatch({
					type: actionTypes.GET_DASHBOARD_LIKE_STAT,
					payload: likeStatusData.length > 0 ? [...likeStatusData] : null,
				});
				dispatch({
					type: actionTypes.SET_DASHBOARD_LIKE_STAT_LOADING,
					payload: false,
				});
			})
			.catch(function (err) {
				console.log("Error in fetching student stat:", err);
				message.error("Error in loading data !");
				dispatch({
					type: actionTypes.SET_DASHBOARD_LIKE_STAT_LOADING,
					payload: false,
				});
			});
	};

export const getDashboardInternshipCount =
	(companyId) =>
	(dispatch, getState, { getFirebase, getFirestore }) => {
		dispatch({
			type: actionTypes.SET_DASHBOARD_INTERNSHIP_COUNT_LOADING,
			payload: true,
		});
		const database = getFirestore();

		database
			.collection("Dashboard_InternshipCount")
			.doc(companyId)
			.get()
			.then((doc) => {
				let data = doc.data();
				dispatch({
					type: actionTypes.GET_DASHBOARD_INTERNSHIP_COUNT,
					payload: data ? { ...data } : null,
				});
				dispatch({
					type: actionTypes.SET_DASHBOARD_INTERNSHIP_COUNT_LOADING,
					payload: false,
				});
			})
			.catch(function (err) {
				console.log("Error in fetching internship count:", err);
				message.error("Error in loading data !");
				dispatch({
					type: actionTypes.SET_DASHBOARD_INTERNSHIP_COUNT_LOADING,
					payload: false,
				});
			});
	};

export const getDashboardCurrentYearStat =
	() =>
	(dispatch, getState, { getFirebase, getFirestore }) => {
		dispatch({
			type: actionTypes.SET_DASHBOARD_CURRENT_YEAR_STAT_LOADING,
			payload: true,
		});
		const database = getFirestore();
		const thirdYearAdmissionYear =
			getAdmissionYearForThirdYearStudents().toString();

		database
			.collection("StudentProfile")
			.where("yearOfAdmission", "==", thirdYearAdmissionYear)
			.get()
			.then((querySnap) => {
				let statData = [];
				querySnap.forEach((doc) => {
					statData.push(doc.data());
				});

				dispatch({
					type: actionTypes.GET_DASHBOARD_CURRENT_YEAR_STAT,
					payload: [...statData],
				});
				dispatch({
					type: actionTypes.SET_DASHBOARD_CURRENT_YEAR_STAT_LOADING,
					payload: false,
				});
			})
			.catch(function (err) {
				console.log("Error in fetching current year stat:", err);
				message.error("Error in loading data !");
				dispatch({
					type: actionTypes.SET_DASHBOARD_CURRENT_YEAR_STAT_LOADING,
					payload: false,
				});
			});
	};

export const getDashboardCalendarEvents =
	(companyId) =>
	(dispatch, getState, { getFirebase, getFirestore }) => {
		dispatch({
			type: actionTypes.SET_DASHBOARD_CALENDAR_EVENTS_LOADING,
			payload: true,
		});
		const database = getFirestore();

		database
			.collection("Dashboard_Calendar")
			.where("companyId", "==", companyId)
			.get()
			.then((querySnap) => {
				let calendarEvents = [];
				querySnap.forEach((doc) => {
					let _data = doc.data();
					calendarEvents.push(_data);
				});
				dispatch({
					type: actionTypes.SET_DASHBOARD_CALENDAR_EVENTS,
					payload: calendarEvents.length > 0 ? [...calendarEvents] : [],
				});
				dispatch({
					type: actionTypes.SET_DASHBOARD_CALENDAR_EVENTS_LOADING,
					payload: false,
				});
			})
			.catch(function (err) {
				console.log("Error in fetching calendar events:", err);
				message.error("Error in loading data !");
				dispatch({
					type: actionTypes.SET_DASHBOARD_CALENDAR_EVENTS_LOADING,
					payload: false,
				});
			});
	};

export const getDashboardData =
	() =>
	(dispatch, getState, { getFirestore }) => {
		let collectionData = getState().organisationData.collectionData;

		if (!collectionData) {
			const database = getFirestore();
			collectionData = database.collection("OrganisationData").get();

			dispatch({
				type: actionTypes.SET_ORGANISATION_DATA_COLLECTION_DATA,
				payload: collectionData,
			});
		}

		collectionData
			.then((querySnapshot) => {
				querySnapshot.forEach((doc) => {
					if (doc.id == "dashboard") {
						const refToYear = doc.ref
							.collection(`${getCurrentAcadimicYear()}`)
							.doc("data");

						// let dashboardData = doc.data();
						refToYear
							.get()
							.then((yearDoc) => {
								let dashboardData = yearDoc.data();

								dispatch({
									type: actionTypes.SET_DASHBOARD_DATA,
									payload: dashboardData,
								});
							})
							.catch((err) => {
								console.log("Dashboard data loading error ", err);
							});
					}
				});
			})
			.catch((err) => {
				console.log("Dashboard data loading error ", err);
			});
	};
